export const NOT_SET = 'not set';

export const awaitGtmReady = async () => {
  return new Promise((resolve) => {
    const dataLayer = window.dataLayer ?? (window.dataLayer = []);
    dataLayer.push({
      event: 'pdpReactApp.GaDispatcherReady',
      eventCallback: resolve,
    });
  });
};
